import {
  Component,
  Input,
  Output,
  ElementRef,
  Renderer2,
  EventEmitter,
  OnInit,
  AfterViewInit,
  QueryList,
  ViewChildren
} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {RxAuthService} from 'src/app/services/rx-auth/rx-auth.service';
import {environment} from 'src/environments/environment';
import html2canvas from 'html2canvas';
import {ViewChild} from '@angular/core';
import {MatTooltipModule} from '@angular/material/tooltip';
import {ActivatedRoute, Router} from '@angular/router';


//charts
import {LineChartComponent} from '../line-chart/line-chart.component';
import {HeatmapComponent} from '../heatmap/heatmap.component';
import {BoxChartComponent} from '../box-chart/box-chart.component';
import {BarChartComponent} from '../bar-chart/bar-chart.component';
import {PieChartComponent} from '../pie-chart/pie-chart.component';


//plotly, used to download svg
import * as Plotly from 'plotly.js-dist-min'
import {ListsService} from 'src/app/services/lists/lists.service';
import {List} from 'src/app/lists/lists-table/lists-table.component';
import {CompanyProfileComponent} from '../company-profile/company-profile.component';
import {VisualizationService} from 'src/app/services/visualization/visualization.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {NgForOf, NgIf} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {MatTabsModule} from '@angular/material/tabs';
import {ChartShareDialogComponent} from '../chart-share-dialog/chart-share-dialog.component';
import * as _ from 'lodash';
import { MetricTableComponent } from '../metric-table/metric-table.component';
import { ProductListComponent } from '../product-list/product-list.component';
import { SingleBarChartComponent } from '../single-bar-chart/single-bar-chart.component';
import { ComparedBarChartComponent } from '../compared-bar-chart/compared-bar-chart.component';


import * as htmlToImage from 'html-to-image';
import {ChartsCommonFunctions} from "../chartsCommonFunctions";
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatIconModule} from '@angular/material/icon';

import {ChartHeaderComponent} from "../chart-header/chart-header.component";

@Component({
  selector: 'app-chart-wrapper',
  templateUrl: './chart-wrapper.component.html',
  styleUrls: ['./chart-wrapper.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    MatTooltipModule,
    FormsModule,
    MatTabsModule,
    NgForOf,
    LineChartComponent,
    HeatmapComponent,
    BoxChartComponent,
    BarChartComponent,
    PieChartComponent,
    CompanyProfileComponent,
    ChartShareDialogComponent,
    MetricTableComponent,
    MatProgressSpinnerModule,
    MatIconModule,
    ProductListComponent,
    SingleBarChartComponent,
    ComparedBarChartComponent


  ],
})
export class ChartWrapperComponent implements OnInit, AfterViewInit {
  constructor(
    private http: HttpClient,
    public auth: RxAuthService,
    private elementref: ElementRef,
    private renderer: Renderer2,
    private route: ActivatedRoute,
    private router: Router,
    private listService: ListsService,
    private visualizationService: VisualizationService,
    public snack: MatSnackBar,
    private common: ChartsCommonFunctions,
  ) {
  }

  @Input() chartType: any = {};
  @Input() rcl: number = 3;
  @Input() retailer: any = '';
  @Input() visualizations: any = null;
  @Input() editable: boolean = false;
  @Input() savedChartListId: number | null = null;
  @Input() visualizationActive:boolean = true;
  //@Input() echelon: any = null;

  @ViewChild('chartcontainer') chartContainer!: ElementRef;
  @ViewChild('shareDialog', {static: false}) shareDialog!: ElementRef;
  @ViewChild('saveDialog', {static: false}) saveDialog!: ElementRef;
  @ViewChild('downloadOverlay', {static: false}) downloadOverlay!: ElementRef;
  @ViewChild('maincontainer', {static: false}) maincontainer!: ElementRef;
  @ViewChild('plot', {static: false}) plot!: ElementRef;

  @ViewChild(LineChartComponent) lineChartComponent!: LineChartComponent;
  @ViewChild(HeatmapComponent) heatmapComponent!: HeatmapComponent;
  @ViewChild(BoxChartComponent) boxChartComponent!: BoxChartComponent;
  @ViewChild(BarChartComponent) barChartComponent!: BarChartComponent;
  @ViewChild(PieChartComponent) pieChartComponent!: PieChartComponent;
  @ViewChild(MetricTableComponent) metricTableComponent!: MetricTableComponent;
  @ViewChild(ProductListComponent) productListComponent!: ProductListComponent;
  @ViewChild(SingleBarChartComponent) SingleBarChartComponent!: SingleBarChartComponent;
  @ViewChild(ComparedBarChartComponent) ComparedBarChartComponent!: ComparedBarChartComponent;
  @ViewChild(CompanyProfileComponent)
  companyProfileComponent!: CompanyProfileComponent;

  chartComponent: any = null;
  selectedChart: any = null;
  chartId: string = '';
  isDownloading: boolean = false;
  displayDialog: boolean = false;

  padlockUrl: string = environment.wp.sign_up_url

  hasBeenWarned: boolean = false;
  showWarning: boolean = false;

  //Compare functionality
  enableCompare: boolean = false; //Displays the compare button and allows the compare functionality to be triggered
  @Output() openCompareDialog = new EventEmitter<void>();

  //Download dialog variables
  showDownloadDialog: boolean = false;
  selectedFormat: string = 'png';
  height: number | null = null;
  width: number | null = null;
  unit: string = 'px';
  preset: string | null = 'recommended';

  //Save dialog variables
  showSaveDialog: boolean = false;
  showLoadInDialog: boolean = false;
  listsData: List[] = [];
  originalListsData: List[] = [];

  selectedLists: number[] = [];

  originalSelectedLists: number[] = [];
  searchText: any = null;
  formData = {
    name: '',
    description: '',
  };
  tabLabel = 'Select list(s)';

  buttonText: string = 'Add to selected list(s)';
  //Issue dialong variables
  showIssueDialog: boolean = false;
  isSaved: boolean = false;

  issueOptions: string[] = [
    "The chart's data is incorrect",
    "The chart doesn't display correctly",
    "There is an error with the chart's text",
    'The app is not working correctly',
    'The chart is miscategorized',
    'Other',
  ];
  plotStateJson: string | null = null;
  originalPlotStateJson: string = '';
  customPlotStateJson: string = '';
  isCustomChart: boolean = false;

  currentRoute: string = '';

  public isChartEditMode: boolean = false; // Local property to track edit mode

  originalTextElements: any = null;
  customTextElements: any = null;

  // Object to store form data
  issueFormData: { selectedOption?: string; description?: string } = {};

  extraLength: number = 0

  validateName(nameField: any): void {
    if (nameField.value.trim() === '') {
      nameField.control.setErrors({required: true});
    } else if (nameField.value.length > 100) {
      nameField.control.setErrors({maxlength: true});
    } else {
      nameField.control.setErrors(null);
    }
  }

  validateDescription(descriptionField: any): void {
    if (descriptionField.value.length > 500) {
      descriptionField.control.setErrors({maxlength: true});
    } else {
      descriptionField.control.setErrors(null);
    }
  }

  ngOnInit() {
    // Get the current route
    this.currentRoute = this.router.url.split('?')[0];
    this.enableCompare = ['line', 'single_bar'].includes(this.chartType.chart_type);

    this.selectChart();
    this.getAllUserLists();

    if (this.selectedChart?.id) {
      this.setCustomPlotState();
      this.checkIfSaved(
        this.selectedChart.id,
        this.rcl,
        this.plotStateJson,
        this.selectedChart.sqa_chart_id
      );
    }
  }

  checkIfCustomChart(): boolean {
    this.originalPlotStateJson = this.captureOriginalPlotState(this.selectedChart.chart_type);
    this.customPlotStateJson = this.captureCustomPlotState(this.selectedChart.chart_type);

    // Returns true if the custom plot is DIFFERENT from the original one
    return this.customPlotStateJson !== this.originalPlotStateJson;
  }

  setCustomPlotState(): void {
    const customPlotCreated = this.checkIfCustomChart();


    this.customPlotStateJson = this.captureCustomPlotState(this.selectedChart.chart_type);
    if (customPlotCreated) {
      this.plotStateJson = this.customPlotStateJson;
      this.selectedChart.customChartJson = this.plotStateJson

    } else {
      this.plotStateJson = null;
      this.selectedChart.customChartJson = this.plotStateJson
    }
  }

  private mapToList(response: any): List[] {
    return response.map((item: any) => ({
      id: item.id,
      list_name: item.list_name,
      shared_with_count: item.shared_with_count,
      creation_date: new Date(item.creation_date),
      last_modified: new Date(item.last_modified),
      charts_count: item.charts_count,
      chart_ids: item.chart_ids,
      custom_ids: item.custom_ids,
      chart_rcl_ids: item.chart_rcl_ids,
      original_chart_pack: item.original_chart_pack || ' - ',
      editor_permission: item.editor_permission,
      owner: item.owner,
    }));
  }

  private sortByName(lists: List[]): List[] {
    return lists.sort((a, b) => a.list_name.localeCompare(b.list_name));
  }

  filterResults() {
    const searchTextLower = this.searchText.toLowerCase();
    // Filter the lists based on the original data
    this.listsData = this.originalListsData.filter((list) =>
      list.list_name.toLowerCase().includes(searchTextLower)
    );
  }

  getAllUserLists() {
    this.listService.getAllUserLists().subscribe(
      (response: any) => {
        // Filter shared_lists to only include those with editor_permission set to true
        const editableSharedLists = response.shared_lists.filter(
          (list: any) => list.editor_permission === true
        );

        // Combine the owned lists with the filtered shared lists
        const combinedLists = response.owned_lists.concat(editableSharedLists);

        // Sort the combined lists by last_modified in descending order (most recent first)
        const sortedLists = combinedLists.sort(
          (a: any, b: any) =>
            new Date(b.last_modified).getTime() -
            new Date(a.last_modified).getTime()
        );

        // Map the sorted lists to the desired format
        const mappedLists = this.mapToList(sortedLists);

        // Ensure listsData has the correct structure and order
        this.listsData = mappedLists; // If you only want to sort by last_modified
        this.originalListsData = mappedLists;

        this.showLoadInDialog = false;

      },
      (error: any) => {
        console.error('Error getting all user lists', error.error.message);
      }
    );
  }

  onTabChange(event: any) {
    this.clearSaveSelection();
    if (event.tab.textLabel === 'Select list(s)') {
      this.tabLabel = 'Select list(s)';
      this.buttonText = 'Add to selected list(s)'; // Set default button text
    } else {
      this.tabLabel = 'Create new list';
      this.buttonText = 'Create list and add chart'; // Update text for the new list tab
    }
  }

  ngAfterViewInit() {
    if (this.selectedChart.chart_type === 'line') {
      this.chartComponent = this.lineChartComponent;
    } else if (this.selectedChart.chart_type === 'heatmap') {
      this.chartComponent = this.heatmapComponent;
    } else if (this.selectedChart.chart_type === 'box') {
      this.chartComponent = this.boxChartComponent;
    } else if (this.selectedChart.chart_type === 'bar') {
      this.chartComponent = this.barChartComponent;
    } else if (this.selectedChart.chart_type === 'pie') {
      this.chartComponent = this.pieChartComponent;
    } else if (this.selectedChart.chart_type === 'companyprofile') {
      this.chartComponent = this.companyProfileComponent;
    } else if (this.selectedChart.chart_type === 'metrictable') {
      this.chartComponent = this.metricTableComponent
    } else if (this.selectedChart.chart_type === 'productlist') {
      this.chartComponent = this.productListComponent
    } else if (this.selectedChart.chart_type === 'single_bar') {
      this.chartComponent = this.SingleBarChartComponent
    } else if (this.selectedChart.chart_type === 'compared_bar') {
      this.chartComponent = this.ComparedBarChartComponent
    }


    // Loop through all visualizations
    this.visualizations.forEach((visualization: any) => {
      // If no custom_chart, skip to the next visualization
      if (!visualization.custom_chart) {
        if (this.currentRoute === '/saved-charts') {
          this.loadCustomTextState(this.selectedChart.chart_type);
        }

        return;
      }

      // If custom_chart is available, load the plot state
      this.loadPlotState(visualization.custom_chart, this.selectedChart.chart_type);
      this.isCustomChart = true;
    });
  }

  selectChart() {
    this.selectedChart = this.visualizations.find(
      (obj: any) => obj.name === this.chartType.name
    );
    if (this.selectedChart) {
      // Add rcl to the selected chart
      this.selectedChart.sqa_chart_id = null;
      this.selectedChart.split = null;
      this.selectedChart.rcl = this.rcl;

      // Update the chart ID with the rcl and selected chart ID
      this.chartId = `RXI${this.rcl}-${this.selectedChart.id}`;
    } else {
      console.error('Selected chart not found.');
    }
  }

  async downloadPNG() {
    this.isDownloading = true;

    let downloadOverlay =
      this.elementref.nativeElement.querySelector('.download-overlay');


    this.renderer.setStyle(downloadOverlay, 'display', 'flex');

    await this.takescreenshot();

    //this.renderer.setStyle(downloadOverlay, 'display', 'none')

    this.isDownloading = false;
  }

  takescreenshot(isShare: boolean = false): Promise<any> {
    return new Promise((resolve) => {
      let elementHeight = this.chartContainer.nativeElement.height;
      let elementWidth = this.chartContainer.nativeElement.width;
      let textElementsHeight = 160;

      setTimeout(() => {
        if (isShare) {
          //Reformat chart and containers to get 1200x630 image for thumbnail
          //this.renderer.setStyle(this.downloadOverlay.nativeElement, 'width', this.chartContainer.nativeElement.width)
          this.renderer.setStyle(
            this.downloadOverlay.nativeElement,
            'display',
            'flex'
          );
          this.renderer.setStyle(
            this.chartContainer.nativeElement,
            'width',
            '1200px'
          );
          this.renderer.setStyle(
            this.chartContainer.nativeElement,
            'height',
            '630px'
          );
          if (this.chartType.chart_type !== 'companyprofile' && this.chartType.chart_type !== 'metrictable' && this.chartType.chart_type !== 'productlist') {
            this.renderer.setStyle(this.plot.nativeElement, 'overflow', 'hidden');
            this.chartComponent.resizeChart(1200, 480, this.chartId);
            elementHeight = 630;
            elementWidth = this.chartContainer.nativeElement.width;
          }
        } else {
          let finalWidth = this.unitToPx(this.width!) + 'px';
          let finalHeight = this.unitToPx(this.height!) + 'px';

          this.renderer.setStyle(
            this.downloadOverlay.nativeElement,
            'display',
            'flex'
          );
          this.renderer.setStyle(
            this.chartContainer.nativeElement,
            'width',
            finalWidth
          );
          this.renderer.setStyle(
            this.chartContainer.nativeElement,
            'height',
            finalHeight
          );
          //this.renderer.setStyle(this.maincontainer.nativeElement, 'height', finalHeight)

          this.renderer.setStyle(this.plot.nativeElement, 'overflow', 'hidden');
          if (this.chartType.chart_type !== 'companyprofile' && this.chartType.chart_type !== 'metrictable'  && this.chartType.chart_type !== 'productlist') {
            this.chartComponent.resizeChart(
              this.unitToPx(this.width!),
              this.unitToPx(this.height!) - textElementsHeight,
              this.chartId
            );
          }
          elementHeight = this.unitToPx(this.height!);
          elementWidth = this.chartContainer.nativeElement.width;
        }
        let proxy = undefined;
        if (this.chartComponent.profileData?.retailerLogo) {
          proxy = this.chartComponent.profileData?.retailerLogo;
        } else if (this.chartType.chart_type === 'metrictable') {
          proxy = this.chartComponent.jsonData.logo
        } else {
          proxy =
            ' https://accounts-app.s3.eu-west-1.amazonaws.com/RetailX-Intelligence_Long.png';
        }


        html2canvas(this.chartContainer.nativeElement, {
          useCORS:true,
          proxy: proxy,
          width: elementWidth,
          height: elementHeight,
        }).then((canvas) => {
          const imageData = canvas.toDataURL('image/png');

          let chartName = '';

          if (this.retailer && this.retailer.name) {
            chartName = `${this.retailer.name}'s ${this.selectedChart.name} RXI${this.rcl}-${this.selectedChart.id}.png`;
          } else {
            let slug = this.route.snapshot.queryParamMap.get('slug');
            let header = ''

            if (this.selectedChart.text_elements.list) { //Prevents from breaking when there is no "list"
              header = this.selectedChart.text_elements.list.header
            } else {
              header = ''
            }

            if (slug !== null) {
              chartName = `${slug} ${header} RXI${this.rcl}-${this.selectedChart.id}.png`;
            } else {
              chartName = `${header} RXI${this.rcl}-${this.selectedChart.id}.png`;
            }
          }
          if (!isShare) {
            const link = this.renderer.createElement('a');
            this.renderer.setAttribute(link, 'download', chartName);
            this.renderer.setAttribute(link, 'href', imageData);
            this.renderer.setStyle(
              this.chartContainer.nativeElement,
              'width',
              '100%'
            );
            this.renderer.setStyle(
              this.chartContainer.nativeElement,
              'height',
              '100%'
            );
            this.renderer.setStyle(
              this.maincontainer.nativeElement,
              'height',
              '500px'
            );
            this.renderer.setStyle(
              this.plot.nativeElement,
              'overflow',
              'hidden'
            );
            if (this.chartType.chart_type !== 'companyprofile' && this.chartType.chart_type !== 'metrictable'  && this.chartType.chart_type !== 'productlist') {
              this.chartComponent.resizeChart(
                this.chartContainer.nativeElement.width - 20,
                300,
                this.chartId
              );
            }
            this.renderer.setStyle(
              this.downloadOverlay.nativeElement,
              'display',
              'none'
            );

            link.click();
          } else {
            this.renderer.setStyle(
              this.chartContainer.nativeElement,
              'width',
              '100%'
            );
            this.renderer.setStyle(
              this.chartContainer.nativeElement,
              'height',
              '100%'
            );
            this.renderer.setStyle(
              this.plot.nativeElement,
              'overflow',
              'hidden'
            );
            if (this.chartType.chart_type !== 'companyprofile' && this.chartType.chart_type !== 'metrictable'  && this.chartType.chart_type !== 'productlist') {
              this.chartComponent.resizeChart(
                this.chartContainer.nativeElement.width - 20,
                300,
                this.chartId
              );
            }
            this.renderer.setStyle(
              this.downloadOverlay.nativeElement,
              'display',
              'none'
            );
            resolve(imageData);
          }
        });

        //resolve('done')
      });
    });
  }

  async toggleShareDialog() {
    this.setCustomPlotState()
    this.displayDialog = !this.displayDialog;

    if (this.displayDialog) {
      setTimeout(() => {
        this.renderer.setStyle(
          this.shareDialog.nativeElement,
          'display',
          'flex'
        );
        if (this.route.component!.name === 'ProfileWrapperComponent') {
          this.renderer.setStyle(
            this.shareDialog.nativeElement,
            'width',
            '585px'
          );
        } else if (this.route.component!.name === 'PublicChartComponent') {
          this.renderer.setStyle(
            this.shareDialog.nativeElement,
            'width',
            '50vw'
          );
        }
      }, 0);


        //Render the new image and send it to the server
        let imageData = await this.takescreenshot(true);
        let url =
          environment.backend_base + 'main/visualizations/upload_thumbnail/';
        let payload = {
          image: imageData,
          rcl: this.rcl,
          visualization: this.selectedChart,
        };

        this.http.post(url, payload).subscribe((response: any) => {
          if (response.status === 'success') {
            this.chartComponent.hasThumbnail = true

          }
        });

    }
  }

  async downloadSVG() {
    const plot = this.chartContainer.nativeElement.querySelector(
      `#plot${this.chartComponent.chartId}`
    );

    const finalWidth = this.unitToPx(this.width!);
    const finalHeight = this.unitToPx(this.height!);
    let textElementsHeight = 100;
    //Font sizes
    const fontSizes = {
      fsHeading: '24',
      fsSubheading: '18',
      fsCaption: '13',
      fsSource: '11',
    };

    // Y positioning
    const yPositioning = {
      yHeading: '20',
      ySubheading: '50',
      yChart: '60',
      yCaption: finalHeight - textElementsHeight * 0.45,
      ySource: (finalHeight - 12).toString(),
    };

    if (this.unit === 'mm') {
      (fontSizes.fsHeading = '13'),
        (fontSizes.fsSubheading = '10'),
        (fontSizes.fsCaption = '8'),
        (fontSizes.fsSource = '8');

      textElementsHeight = 75;

      yPositioning.ySubheading = '36';
      yPositioning.yChart = '37';
    }

    // Clone the chart layout to avoid modifying the original object
    const newLayout = { ...this.chartComponent.chartData.layout };

    newLayout.font = { size: +fontSizes.fsCaption };
    newLayout.yaxis = { tickfont: { size: +fontSizes.fsCaption } };
    newLayout.xaxis = { tickfont: { size: +fontSizes.fsCaption } };
    newLayout.legend = { font: { size: +fontSizes.fsCaption } };

    await Plotly.relayout(plot, {
      font: { size: +fontSizes.fsCaption },
      legend: { ...plot.layout.legend, y: 100 },
    });

    const plotHeight = finalHeight - textElementsHeight;
    const svgDataUrl = await Plotly.toImage(plot, {
      format: 'svg',
      width: finalWidth,
      height: plotHeight,
    });
    const response = await fetch(svgDataUrl);
    const svgText = await response.text();

    const stringifiedWidth = finalWidth.toString();
    const stringifiedHeight = finalHeight.toString();

    const serializer = new XMLSerializer();

    const svgElem = document.createElementNS(
      'http://www.w3.org/2000/svg',
      'svg'
    );
    svgElem.setAttribute('width', stringifiedWidth);
    svgElem.setAttribute('height', stringifiedHeight);
    svgElem.setAttribute(
      'viewBox',
      `0 0 ${stringifiedWidth} ${stringifiedHeight}`
    );
    //svgElem.setAttribute('style', 'border: 1px solid black'); //Add a black border to see the original sizing

    // Add Plotly SVG content
    const plotlySvg = new DOMParser().parseFromString(
      svgText,
      'image/svg+xml'
    ).documentElement;
    plotlySvg.setAttribute('y', yPositioning.yChart);
    svgElem.appendChild(plotlySvg);

    // Add other SVG elements (heading, subheading, caption, source)

    //Heading
    const heading = document.createElementNS(
      'http://www.w3.org/2000/svg',
      'text'
    );
    heading.setAttribute('x', '10');
    heading.setAttribute('y', yPositioning.yHeading);
    heading.setAttribute('class', 'left');
    heading.setAttribute('font-size', fontSizes.fsHeading);
    heading.setAttribute('font-family', 'Arial');
    heading.setAttribute('line-height', '24px');
    heading.setAttribute('font-weight', 'bold');
    heading.setAttribute('fill', '#282B59');
    heading.textContent = this.chartComponent.text_elements.header;
    svgElem.appendChild(heading);

    //Logo
    const logoWidth = finalWidth * 0.15;
    const image = document.createElementNS(
      'http://www.w3.org/2000/svg',
      'image'
    );
    image.setAttributeNS(
      'http://www.w3.org/1999/xlink',
      'href',
      'https://accounts-app.s3.eu-west-1.amazonaws.com/RetailX-Intelligence_Long.svg'
    );
    image.setAttribute('x', (finalWidth - logoWidth).toString()); // x position
    image.setAttribute('y', '-25'); // y position, adjust as needed
    image.setAttribute('width', logoWidth.toString()); // width of the image
    image.setAttribute('height', '100'); // height of the image
    svgElem.appendChild(image);

    //Line
    const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
    const textY = parseFloat(yPositioning.yHeading); // Convert y position to a number
    const textFontSize = parseFloat(fontSizes.fsHeading); // Convert font size to a number
    line.setAttribute('x1', '10'); // Start of the line (same x as text)
    line.setAttribute('x2', stringifiedWidth); // Start of the line (same x as text)
    line.setAttribute('y1', (+yPositioning.ySubheading + 7).toString()); // Start of the line (same x as text)
    line.setAttribute('y2', (+yPositioning.ySubheading + 7).toString()); // Start of the line (same x as text)
    line.setAttribute('stroke', '#282B59'); // Color of the line
    line.setAttribute('stroke-width', '3'); // Thickness of the line
    svgElem.appendChild(line);

    //Subheading
    const subheading = document.createElementNS(
      'http://www.w3.org/2000/svg',
      'text'
    );
    subheading.setAttribute('x', '10');
    subheading.setAttribute('y', yPositioning.ySubheading);
    subheading.setAttribute('class', 'left');
    subheading.setAttribute('font-size', fontSizes.fsSubheading);
    subheading.setAttribute('font-family', 'Arial');
    subheading.setAttribute('line-height', '22px');
    subheading.setAttribute('font-weight', 'bold');
    subheading.setAttribute('fill','#0CAD99');
    subheading.textContent = this.chartComponent.text_elements.subheader;
    svgElem.appendChild(subheading);

    //Function to wrap caption, used below
    function wrapText(
      text: string,
      maxWidth: number,
      charWidth: number = 10
    ): string[] {
      const words = text.split(' ');
      const lines: string[] = [];
      let currentLine = '';

      words.forEach((word) => {
        const testLine = currentLine + (currentLine ? ' ' : '') + word;
        if (testLine.length * charWidth > maxWidth) {
          lines.push(currentLine);
          currentLine = word;
        } else {
          currentLine = testLine;
        }
      });

      if (currentLine) {
        lines.push(currentLine);
      }

      return lines;
    }

    //Caption
    const captionLines = wrapText(
      this.chartComponent.text_elements.caption,
      finalWidth * 2.5
    ); // Adjust maxWidth as needed
    const captionY = yPositioning.yCaption;
    captionLines.forEach((line, index) => {
      const tspan = document.createElementNS(
        'http://www.w3.org/2000/svg',
        'text'
      );
      tspan.setAttribute('x', '10');
      tspan.setAttribute(
        'y',
        (captionY + index * (+fontSizes.fsCaption * 1.4)).toString()
      );
      tspan.setAttribute('class', 'left');
      tspan.setAttribute('font-size', fontSizes.fsCaption);
      tspan.setAttribute('font-family', 'Arial');
      tspan.textContent = line;
      svgElem.appendChild(tspan);
    });

    //Line
    const line2 = document.createElementNS(
      'http://www.w3.org/2000/svg',
      'line'
    );
    line2.setAttribute('x1', '10'); // Start of the line (same x as text)
    line2.setAttribute('x2', stringifiedWidth); // Start of the line (same x as text)
    line2.setAttribute('y1', (finalHeight - 25).toString()); // Start of the line (same x as text)
    line2.setAttribute('y2', (finalHeight - 25).toString()); // Start of the line (same x as text)
    line2.setAttribute('stroke', '#282B59'); // Color of the line
    line2.setAttribute('stroke-width', '3'); // Thickness of the line
    svgElem.appendChild(line2);

    //Source
    const source = document.createElementNS(
      'http://www.w3.org/2000/svg',
      'text'
    );
    source.setAttribute('x', '10');
    source.setAttribute('y', (finalHeight - 12).toString());
    source.setAttribute('class', 'left');
    source.setAttribute('font-size', fontSizes.fsSource);
    source.setAttribute('font-family', 'Arial');
    source.setAttribute('fill', '#9e9e9e');
    source.textContent = `Source: ${this.chartComponent.text_elements.source}`;
    svgElem.appendChild(source);


    if (finalWidth === 1200) {
      this.extraLength = 10
    }
    else {
      this.extraLength = 25
    }

    //Chart ID
    const id = document.createElementNS('http://www.w3.org/2000/svg', 'text');
    id.setAttribute(
      'x',
      (finalWidth - (this.chartComponent.chartId.length * 7) + this.extraLength).toString()
    );
    id.setAttribute('y', (finalHeight - 12).toString());
    id.setAttribute('class', 'right');
    id.setAttribute('font-size', fontSizes.fsSource);
    id.setAttribute('font-family', 'Arial');
    id.setAttribute('fill', '#9e9e9e');
    id.textContent = `${this.chartComponent.chartId}`;
    svgElem.appendChild(id);

    //Copyright
    const copyLogoWidth = finalWidth * 0.08;

    const imageElement = document.createElementNS(
      'http://www.w3.org/2000/svg',
      'image'
    );
    imageElement.setAttributeNS(
      'http://www.w3.org/1999/xlink',
      'href',
      'https://accounts-app.s3.eu-west-1.amazonaws.com/copyright-retailx.jpg'
    );

    imageElement.setAttribute('x', (finalWidth - (copyLogoWidth * 1)).toString()); // x position
    imageElement.setAttribute('y', (finalHeight - 55).toString()); // y position, adjust as needed
    imageElement.setAttribute('width', copyLogoWidth.toString()); // width of the image
    imageElement.setAttribute('height', '100'); // height of the image
    svgElem.appendChild(imageElement);

    const svgString = serializer.serializeToString(svgElem);
    const blob = new Blob([svgString], {type: 'image/svg+xml;charset=utf-8'});
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = `chart-${this.chartComponent.chartId}.svg`;
    a.click();
    Plotly.relayout(plot, plot.layout);
    URL.revokeObjectURL(url);
  }

  //Download dialog functions
  switchDialogs() {
    this.toggleDownloadDialog();
    this.toggleShareDialog();
  }

  toggleDownloadDialog() {
    this.showDownloadDialog = !this.showDownloadDialog;
    if (this.showDownloadDialog) {
      this.onDownloadPresetChange(this.preset); //Initialize first download value according to selected format and preset
    }
  }

  clearDownloadSelection() {
    this.width = null;
    this.height = null;
    this.unit = 'px';
    this.preset = null;
  }

  clearSaveSelection() {
    this.selectedLists = _.cloneDeep(this.originalSelectedLists);
    this.tabLabel = '';
  }

  isCurrentListSelectedTab(tabLabel: string): boolean {
    if (tabLabel === 'Select list(s)' && this.selectedLists.length > 0) {
      return !!(this.selectedLists.length > 0);
    } else {
      return false;
    }
  }

  onCheckboxChange(event: any, listId: number) {
    if (event.target.checked) {
      // Add the list ID to the selectedLists array if checked
      if (!this.selectedLists.includes(listId)) {
        this.selectedLists.push(listId);
      }
    } else {
      // Remove the list ID from the selectedLists array if unchecked
      this.selectedLists = this.selectedLists.filter((id) => id !== listId);
    }
  }

  isSaveEnabled(tabLabel: string): boolean {
    if (tabLabel === 'Select list(s)' && this.selectedLists.length > 0) {
      return true;
    } else {
      return (
        this.formData.name.trim() !== '' &&
        this.formData.name.trim().length <= 100 &&
        this.formData.description.trim().length <= 500
      );
    }
  }

  onDownloadPresetChange(event: any) {
    if (event === 'recommended') {
      if (this.selectedFormat === 'png') {
        this.width = 600;
        this.height = 500;
        this.unit = 'px';
      } else {
        this.width = 179;
        this.height = 75;
        this.unit = 'mm';
      }
    } else if (event === '1200x630px') {
      this.width = 1200;
      this.height = 630;
      this.unit = 'px';
    } else if (event === '179x75mm') {
      this.width = 179;
      this.height = 75;
      this.unit = 'mm';
    } else if (event === '179x159mm') {
      this.width = 179;
      this.height = 159;
      this.unit = 'mm';
    } else if (event === '85x75mm') {
      this.width = 85;
      this.height = 75;
      this.unit = 'mm';
    } else if (event === '128x68mm') {
      this.width = 128;
      this.height = 68;
      this.unit = 'mm';
    } else if (event === '210x297mm') {
      this.width = 210;
      this.height = 297;
      this.unit = 'mm';
    } else if (event === '297x210mm') {
      this.width = 297;
      this.height = 210;
      this.unit = 'mm';
    } else if (event === '148x210mm') {
      this.width = 148;
      this.height = 210;
      this.unit = 'mm';
    } else if (event === '210x148mm') {
      this.width = 210;
      this.height = 148;
      this.unit = 'mm';
    }
    /*
  [two charts on a page] 179mm wide x 75mm high.
  [One on a page] 179mm wide x 159mm high.
  [Four to a page with text on the left] 85mm wide x 75mm high.
  [Four to a page without text I.E Graphics pages] 128mm wide x 68mm high.*/
  }

  onDownloadAccept() {
    if (this.selectedFormat === 'svg') {
      this.downloadSVG();
    } else if (this.selectedFormat === 'png') {
      this.downloadPNG();
    }
  }

  unitToPx(value: number) {
    if (this.unit === 'mm') {
      //let mm = 3.78 //This is the original px to mm conversion rate
      //let mm = 2.11
      //let mm = 2.365
      //let mm = 2.5
      let mm = 2.8;
      return value * mm;
    } else return value;
  }

  reduceListDataToSelected(listData: any): number[] {
    return listData.reduce((acc: number[], list: any) => {
      // Find the index where selectedChart.id matches in chart_ids
      const index = list.chart_ids.indexOf(this.selectedChart.id);

      // Check if rcl at the same index matches this.rcl
      if (index !== -1 && list.chart_rcl_ids[index] === this.rcl) {
        acc.push(list.id); // Push the list id to the accumulator
      }
      return acc;
    }, []);
  }

  toggleSaveDialog() {
    this.tabLabel = 'Select list(s)';
    this.getAllUserLists();

    this.selectedLists = this.reduceListDataToSelected(this.listsData);
    this.originalSelectedLists = this.reduceListDataToSelected(this.listsData);
    this.showLoadInDialog = true;

    this.formData = {
      name: '',
      description: '',
    };

    this.setCustomPlotState()
    this.checkIfSaved(this.selectedChart.id, this.rcl, this.plotStateJson, this.selectedChart.sqa_chart_id);
    this.showSaveDialog = !this.showSaveDialog;

  }

  splitId(idString: string): { rcl_id: number; vis_id: number; cus_id: number | null } {

    // Updated regex: correctly matches RXI-2878-3-12 format
    const pattern = /^RXI(\d+)-(\d+)(?:-(\d+))?$/

    const match = idString.trim().match(pattern);

    if (match) {
      const rcl_id = parseInt(match[1], 10);  // First captured group
      const vis_id = parseInt(match[2], 10);  // Second captured group
      const cus_id = match[3] ? parseInt(match[3], 10) : null; // Optional fourth group (cus_id)

      return {rcl_id, vis_id, cus_id};
    } else {
      throw new Error('Invalid ID format');
    }
  }

  addVisToListAndReset(list_id: number, vis_id: number, rcl_id: number) {
    this.setCustomPlotState()
    this.listService.addVisualizationToList(list_id, vis_id, rcl_id, this.chartId, this.plotStateJson, null).subscribe(
      (response: any) => {
        console.log('Visualization added to list successfully');
        this.formData = {name: '', description: ''};
        // this.selectedLists = [];
        this.showSaveDialog = false;
        this.getAllUserLists();
        this.checkIfSaved(this.selectedChart.id, this.rcl, this.plotStateJson, this.selectedChart.sqa_chart_id);
      },
      (error: any) => {
        console.error('Error adding vis to list:', error.error.error);
      }
    );
  }

  removeVisFromList(list_id: number, vis_id: number, rcl_id: number, customID: string | null, sqaChartID: number | null): void {
    this.listService
      .removeVisualizationFromList(list_id, vis_id, rcl_id, customID, sqaChartID)
      .subscribe(
        (response: any) => {
          console.log('Visualization removed to list successfully');
          this.formData = {name: '', description: ''};
          this.selectedLists = [];
          this.getAllUserLists();
        },
        (error: any) => {
          console.error('Error adding vis to list:', error.error.error);
        }
      );
  }

  saveSelectedLists(chartId: string) {
    const {rcl_id, vis_id, cus_id} = this.splitId(chartId);

    // Ensure we only process lists that have actually changed
    const updatedLists = new Set(this.selectedLists); // Convert to Set for easy lookup
    const originalLists = new Set(this.originalSelectedLists);

    const listsToRemoveFrom = this.originalSelectedLists.filter(id => !updatedLists.has(id));
    const listsToAddTo = this.selectedLists

    // Process removals
    listsToRemoveFrom.forEach(listId => {
      this.removeVisFromList(listId, vis_id, rcl_id, this.selectedChart.custom_id, this.selectedChart.sqa_chart_id);
    });

    // Process additions
    listsToAddTo.forEach(listId => {
      this.addVisToListAndReset(listId, vis_id, rcl_id);
    });

    // Notify user about changes
    let messages: string[] = [];
    if (listsToAddTo.length > 0) messages.push(`Chart added to ${listsToAddTo.length} list(s).`);
    if (listsToRemoveFrom.length > 0) messages.push(`Chart removed from ${listsToRemoveFrom.length} list(s).`);

    if (messages.length > 0) {
      let snackRef = this.snack.open(messages.join(' '), 'Close');
      snackRef._dismissAfter(5000);
    } else {
      console.error('Please select at least one list');
    }

    // Close the dialog
    this.toggleSaveDialog();

    // Update state
    this.setCustomPlotState();

    // Refresh saved status
    this.checkIfSaved(vis_id, rcl_id, this.plotStateJson, this.selectedChart.sqa_chart_id);
  }

  addNewList(chartId: string) {
    const {rcl_id, vis_id} = this.splitId(chartId);
    const name = this.formData.name;
    const description = this.formData.description;

    this.listService.createList(name, description).subscribe(
      (response: any) => {
        console.log('List created successfully');
        const list_id = response.list_id;
        this.addVisToListAndReset(list_id, vis_id, rcl_id);
        let snackRef = this.snack.open(
          'New list created and chart added successfully',
          'Close '
        );
        snackRef._dismissAfter(5000);
      },
      (error: any) => {
        console.error('Error creating list:', error.error.error);
        // Handle the error response here (e.g., display an error message to the user)
      }
    );
  }

  whatIsThisRerouting(chartID: number): void {
    // Keep the base URL without a trailing slash before the fragment
    const baseUrl = `${environment.wp.frontend_base}our-methodology/`;

    // Construct the URL using the chartID, ensuring the '#' is directly appended
    const newUrl = `${baseUrl}#${chartID}`;

    // Redirect the window to the new URL
    window.location.href = newUrl;
  }

  toggleIssueDialog() {
    this.showIssueDialog = !this.showIssueDialog;
    this.clearIssueSelection();
  }

  isIssueSaveEnabled(): boolean {
    // Check if selectedOption is defined and not an empty string
    return !!this.issueFormData.selectedOption; // Using double negation to convert to boolean
  }

  submitIssue(chartId: string) {
    const {rcl_id, vis_id, cus_id} = this.splitId(chartId);
    this.visualizationService
      .addVisualizationIssue(vis_id, rcl_id, null, cus_id, this.issueFormData)
      .subscribe(
        (response: any) => {
          console.log('Visualization issue submitted successfully');
          this.clearIssueSelection();
          this.toggleIssueDialog();
          let snackRef = this.snack.open(
            `Chart issue submitted successfully`,
            'Close '
          );
          snackRef._dismissAfter(5000);
        },
        (error: any) => {
          console.error(
            'Error submitting visualization issue:',
            error.error.error
          );
          // Handle the error response here (e.g., display an error message to the user)
        }
      );
  }

  clearIssueSelection() {
    this.issueFormData = {};
  }

  openCompareDialogEmit() {
    this.openCompareDialog.emit();
  }

  checkIfSaved(chartId: number, rclId: number, customChartJson: any | null, sqaID: any | null) {

    this.listService.isVisualizationSaved(chartId, rclId, customChartJson, sqaID).subscribe(
      (response: any) => {
        this.isSaved = response.exists; // Update isSaved property with the API response
      },
      (error: any) => {
        console.error(
          'Error in checking visualization saved status:',
          error
        );
        this.isSaved = false; // Fallback in case of error
      }
    );
  }

  captureOriginalPlotState(chartType: string): string {
    let originalPlotDiv: any;

    switch (chartType) {
      case 'line':
        originalPlotDiv = this.lineChartComponent?.originalChart;
        break;
      case 'heatmap':
        originalPlotDiv = this.heatmapComponent?.originalChart;
        break;
      case 'box':
        originalPlotDiv = this.boxChartComponent?.originalChart;
        break;
      case 'bar':
        originalPlotDiv = this.barChartComponent?.originalChart;
        break;
      case 'pie':
        originalPlotDiv = this.pieChartComponent?.originalChart;
        break;
      case 'companyprofile':
        break;
      case 'metrictable':
        break;
      case 'productlist':
        break;
      case 'single_bar':
      originalPlotDiv = this.SingleBarChartComponent?.plotlyChart;
        break;
      case 'compared_bar':
      originalPlotDiv = this.ComparedBarChartComponent?.plotlyChart;
        break;
      default:
        console.error('Unsupported chart type:', chartType);
        return JSON.stringify({error: 'Unsupported chart type'});
    }

    if (!originalPlotDiv || !originalPlotDiv.layout) {
      // console.warn("Plotly chart not initialized yet for", chartType);
      return JSON.stringify({error: 'Plotly chart not initialized'}); // Avoid returning `{}`.
    }

    const zoomState = {
      xaxis: originalPlotDiv.layout?.xaxis?.range || [],
      yaxis: originalPlotDiv.layout?.yaxis?.range || [],
    };

    const legendState = originalPlotDiv.data ? originalPlotDiv.data.map((trace: any) => trace.visible ?? null) : [];

    return this.savePlotState(zoomState, legendState, originalPlotDiv.layout, originalPlotDiv.data);
  }

  captureCustomPlotState(chartType: string): string {
    let customPlotDiv: any;


    switch (chartType) {
      case 'line':
        customPlotDiv = this.lineChartComponent?.plotlyChart;
        break;
      case 'heatmap':
        customPlotDiv = this.heatmapComponent?.plotlyChart;
        break;
      case 'box':
        customPlotDiv = this.boxChartComponent?.plotlyChart;
        break;
      case 'bar':
        customPlotDiv = this.barChartComponent?.plotlyChart;
        break;
      case 'pie':
        customPlotDiv = this.pieChartComponent?.plotlyChart;
        break;
      case 'companyprofile':
        break;
      case 'metrictable':
        break;
      case 'productlist':
        break;
      case 'single_bar':
      customPlotDiv = this.SingleBarChartComponent?.plotlyChart;
        break;
      case 'compared_bar':
      customPlotDiv = this.ComparedBarChartComponent?.plotlyChart;
        break;
      default:
        console.error('Unsupported chart type:', chartType);
        return JSON.stringify({error: 'Unsupported chart type'});
    }

    if (!customPlotDiv || !customPlotDiv.layout) {
      // console.warn("Plotly chart not initialized yet for", chartType);
      return JSON.stringify({error: 'Plotly chart not initialized'}); // Avoid returning `{}`.
    }

    const zoomState = {
      xaxis: customPlotDiv.layout?.xaxis?.range || [],
      yaxis: customPlotDiv.layout?.yaxis?.range || [],
    };

    const legendState = customPlotDiv.data ? customPlotDiv.data.map((trace: any) => trace.visible ?? null) : [];

    return this.savePlotState(zoomState, legendState, customPlotDiv.layout, customPlotDiv.data);
  }

  savePlotState(zoomState: any, legendState: any, layout: any, data: any): string {
    const plotState = {
      zoomState,
      legendState,
      layout,
      data,
    };

    return JSON.stringify(plotState, (key, value) =>
      typeof value === 'function' || value === undefined ? undefined : value
    );
  }

  getChartComponent(chartType: string) {
    const componentMap: Record<string, any> = {
      line: this.lineChartComponent,
      heatmap: this.heatmapComponent,
      box: this.boxChartComponent,
      bar: this.barChartComponent,
      pie: this.pieChartComponent
    };
    return componentMap[chartType];
  }

  setCustomTextChartComponent(component: any) {
    if (component && component.text_elements) {
      if(this.visualizations[0].custom_text_elements) {
        component.text_elements.header = this.visualizations[0].custom_text_elements.header
        component.text_elements.subheader = this.visualizations[0].custom_text_elements.subheader
        component.text_elements.caption = this.visualizations[0].custom_text_elements.caption
      }
      else{
        console.log('No custom_text_elements found in visualization');
      }
    }
    else {
      console.log('No component elements found');
    }
  }

  loadPlotState(plotStateJson: string, chartType: string) {
    try {
      const plotState = JSON.parse(plotStateJson);


      const retryLoadPlotState = (retries = 5, delay = 500) => {
        setTimeout(() => {
          const component = this.getChartComponent(chartType)

          if (!component) {
            console.warn(`Component for ${chartType} is not initialized yet. Retrying...`);
          }

          let customPlotDiv = component?.plotlyChart;

          if (customPlotDiv) {

            this.setCustomTextChartComponent(component);

            this.chartId = this.selectedChart.custom_id;
            Plotly.react(customPlotDiv, plotState.data, plotState.layout)
              .then(() => {
                console.log("New plot successfully rendered");
                this.setCustomPlotState()
                this.checkIfSaved(this.selectedChart.id, this.rcl, this.plotStateJson, this.selectedChart.sqa_chart_id);
              })
              .catch(error => console.error("Error rendering new plot:", error));
          } else if (retries > 0) {
            console.warn(`Retrying plot load (${5 - retries} of 5)...`);
            retryLoadPlotState(retries - 1, delay * 1.5); // Increase delay slightly each retry
          } else {
            console.error("No valid plot component found after multiple attempts");
          }
        }, delay);
      };

      retryLoadPlotState();

    } catch (error) {
      console.error("Error parsing plot state JSON:", error);
    }
  }

  loadCustomTextState(chartType: string) {
    try {

      const retryLoadPlotState = (retries = 5, delay = 500) => {
        setTimeout(() => {
          const component = this.getChartComponent(chartType)

          if (!component) {
            console.warn(`Component for ${chartType} is not initialized yet. Retrying...`);
          }

          let customPlotDiv = component?.plotlyChart;

          if (customPlotDiv) {

            this.setCustomTextChartComponent(component);

          } else if (retries > 0) {
            console.warn(`Retrying plot load (${5 - retries} of 5)...`);
            retryLoadPlotState(retries - 1, delay * 1.5); // Increase delay slightly each retry
          } else {
            console.error("No valid plot component found after multiple attempts");
          }
        }, delay);
      };

      retryLoadPlotState();

    } catch (error) {
      console.error("Error parsing plot state JSON:", error);
    }
  }

  toggleEditModeOn() {
    this.getOriginalTextElements()
    this.isChartEditMode = !this.isChartEditMode;
  }

  toggleEditModeOff() {

    this.resetTextElements();
    this.isChartEditMode = !this.isChartEditMode;
  }

  resetTextElements() {
    this.getCurrentTextElements()
    const jsonOriginalTextElements = JSON.stringify(this.originalTextElements)
    const jsonCustomTextElements = JSON.stringify(this.customTextElements)

    if (jsonOriginalTextElements !== jsonCustomTextElements) {
      // Get Header
      const headerElement = document.querySelector('.rDNA-header') as HTMLElement;
      if (headerElement) headerElement.innerText = this.originalTextElements.header; // Change as needed

      // Get Subheader
      const subheaderElement = document.querySelector('.rDNA-subheader') as HTMLElement;
      if (subheaderElement) subheaderElement.innerText = this.originalTextElements.subheader; // Change as needed

      // Get Caption
      const captionElement = document.querySelector('.caption') as HTMLElement;
      if (captionElement) captionElement.innerText = this.originalTextElements.caption; // Change as needed


      let msg = "Chart texts elements reset to original text"
      this.snack.open(msg, '', {duration:3000})

    }

  }

  getOriginalTextElements() {

    // Get Header
    const headerElement = document.querySelector('.rDNA-header') as HTMLElement;
    const editedHeader = headerElement ? headerElement.innerText.trim() : '';

    // Get Subheader
    const subheaderElement = document.querySelector('.rDNA-subheader') as HTMLElement;
    const editedSubheader = subheaderElement ? subheaderElement.innerText.trim() : '';

    // Get Caption
    const captionElement = document.querySelector('.caption') as HTMLElement;
    const editedCaption = captionElement ? captionElement.innerText.trim() : '';

    this.originalTextElements = {
      "header": editedHeader,
      "subheader": editedSubheader,
      "caption": editedCaption,
    }
  }

  getCurrentTextElements() {

    // Get Header
    const headerElement = document.querySelector('.rDNA-header') as HTMLElement;
    const editedHeader = headerElement ? headerElement.innerText.trim() : '';

    // Get Subheader
    const subheaderElement = document.querySelector('.rDNA-subheader') as HTMLElement;
    const editedSubheader = subheaderElement ? subheaderElement.innerText.trim() : '';

    // Get Caption
    const captionElement = document.querySelector('.caption') as HTMLElement;
    const editedCaption = captionElement ? captionElement.innerText.trim() : '';

    this.customTextElements = {
      "header": editedHeader,
      "subheader": editedSubheader,
      "caption": editedCaption,
    }
  }

  saveCustomTextElements() {
    this.getCurrentTextElements()

    const jsonOriginalTextElements = JSON.stringify(this.originalTextElements)
    const jsonCustomTextElements = JSON.stringify(this.customTextElements)

    if (jsonOriginalTextElements !== jsonCustomTextElements) {

      if (this.savedChartListId !== null) {
        this.listService.saveCustomTextElements(this.savedChartListId, this.visualizations[0], this.customTextElements).subscribe(
          (response: any) => {
            this.toggleEditModeOn()

            let msg = 'Edited texts elements saved'
            this.snack.open(msg, '', {duration:3000})
          },
          (error: any) => {
            console.log("error", error);
          }
        )
      } else {
        console.error("Saved chart list id is required to save customTextElements");
      }
    }
    else {

      let msg = "There are no custom text elements changes"

      this.snack.open(msg, '', {duration:3000})
    }




  }

}
